// extracted by mini-css-extract-plugin
export default {"projects-container":"TestimonialsSection_projects-container__hkz7L","title":"TestimonialsSection_title__6RV7S","description":"TestimonialsSection_description__sAWqc"};